module.exports = __webpack_public_path__ + "img/logoBorder.05325224.jpg";